import {
  EventsApi,
  EventTypeResponse,
  CreateEventTypeRequest,
  UpdateEventTypeRequest,
  EventTypeListResponse
} from 'we-tree-api-client/v2';

import { getApiConfiguration } from '@/services/SessionService';
import { ApiResult, withApiSetup } from './apiWrapper';

/**
 * Wrapped event types API with standardized error handling
 */
class WrappedEventTypesApi {
  /**
   * List all event types
   */
  async listEventTypes(isActive?: boolean): Promise<ApiResult<EventTypeListResponse>> {
    return withApiSetup(
      (config) => new EventsApi(config),
      getApiConfiguration,
      (api) => api.listEventTypes(isActive)
    );
  }

  /**
   * Get an event type by ID
   */
  async getEventType(eventTypeId: string): Promise<ApiResult<EventTypeResponse>> {
    return withApiSetup(
      (config) => new EventsApi(config),
      getApiConfiguration,
      (api) => api.getEventType(eventTypeId)
    );
  }

  /**
   * Get an event type by slug
   */
  async getEventTypeBySlug(slug: string): Promise<ApiResult<EventTypeResponse>> {
    return withApiSetup(
      (config) => new EventsApi(config),
      getApiConfiguration,
      (api) => api.getEventTypeBySlug(slug)
    );
  }

  /**
   * Create a new event type
   */
  async createEventType(eventTypeData: CreateEventTypeRequest): Promise<ApiResult<EventTypeResponse>> {
    return withApiSetup(
      (config) => new EventsApi(config),
      getApiConfiguration,
      (api) => api.createEventType(eventTypeData)
    );
  }

  /**
   * Update an existing event type
   */
  async updateEventType(
    eventTypeId: string,
    eventTypeData: UpdateEventTypeRequest
  ): Promise<ApiResult<EventTypeResponse>> {
    return withApiSetup(
      (config) => new EventsApi(config),
      getApiConfiguration,
      (api) => api.updateEventType(eventTypeId, eventTypeData)
    );
  }

  /**
   * Delete an event type
   */
  async deleteEventType(eventTypeId: string): Promise<ApiResult<void>> {
    return withApiSetup(
      (config) => new EventsApi(config),
      getApiConfiguration,
      (api) => api.deleteEventType(eventTypeId)
    );
  }
}

/**
 * Wrapped event types API instance with standardized error handling
 */
export const eventTypesApi = new WrappedEventTypesApi();

export default eventTypesApi;
